import { useCallback, useEffect, useState } from 'react'
import { getAutomationActionStatuses } from '../services/automationSettingsApi'
import type { AutomationActionStatus } from '../types'

// Read-only, same "any workspace member can view" access as useAutomationSettings —
// this is just an activity summary, no gating beyond that.
export function useAutomationActionStatuses(workspaceId: string) {
  const [statuses, setStatuses] = useState<Record<string, AutomationActionStatus>>({})
  const [loading, setLoading] = useState(true)

  const load = useCallback(() => {
    let cancelled = false
    setLoading(true)
    getAutomationActionStatuses(workspaceId)
      .then((result) => { if (!cancelled) setStatuses(result) })
      // Best-effort — a failure here shouldn't block the settings table itself from
      // rendering, so no error state surfaced beyond just showing no status line.
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [workspaceId])

  useEffect(() => load(), [load])

  return { statuses, loading, retry: load }
}
